import _decamelizeKeys from 'decamelize-keys'

export const decamelizeKeys = <T extends Record<string, unknown> | ReadonlyArray<Record<string, unknown>>>(val: T) =>
  _decamelizeKeys(val, { deep: true })
